// extracted by mini-css-extract-plugin
export default {"wrapper":"SNn3l","mobileWrapper":"s-D-4","activityPromotionText":"_1gCTD","desktopWrapper":"HKIhL","supportedNumber":"IKRPm","supportedText":"DZRAc"};